import axios from "axios";
import apiConfig from "./apiConfig";

const axiosInstance = axios.create({
  baseURL: apiConfig.BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const authorization = localStorage.getItem("authorization");

    if (authorization) {
      config.headers["authorization"] = authorization;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      return Promise.reject(error);
    }

    const { status, data } = error.response;

    const authErrors = [
      "Invalid token",
      "Token expired",
      "Unauthorized",
      "Session expired",
      "Auth token invalid",
      "No authorization header",
    ];

    // Logout ONLY if message matches token-related failure
    if (
      status === 401 ||
      (status === 403 && authErrors.includes(data?.message))
    ) {
      localStorage.removeItem("authorization");
      window.location.href = "/auth/sign-in";
      return;
    }

    // Otherwise, do NOT logout
    return Promise.reject(error);
  }
);

export default axiosInstance;
